import * as React from 'react'

import { Checkbox } from '~/client/src/shared/components/shadcn-ui/checkbox'

interface IProps {
  label: string
  checked?: boolean
  indeterminate?: boolean
  onToggle?: () => void
  action?: React.ReactNode
}

const OptionsListHeader: React.FC<IProps> = ({
  label,
  checked,
  indeterminate,
  onToggle,
  action,
}) => {
  return (
    <div
      data-slot="options-list-header"
      className="tw:flex tw:items-center tw:gap-2 tw:pl-1.5 tw:pr-2 tw:shrink-0"
    >
      {onToggle && (
        <button
          type="button"
          onClick={onToggle}
          aria-label="Toggle all"
          className="tw:bg-transparent tw:border-0 tw:cursor-pointer tw:p-0 tw:appearance-none tw:outline-none tw:inline-flex"
        >
          <Checkbox
            checked={checked}
            indeterminate={indeterminate}
            displayOnly
          />
        </button>
      )}
      <span className="tw:flex-1 tw:min-w-0 tw:text-app-dense tw:text-muted-foreground tw:truncate">
        {label}
      </span>
      {action}
    </div>
  )
}

export default OptionsListHeader
